// Instance
import MainAPI from "@/app/apis/main/main-api.js";

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js";

// Query String
const queryString = require("querystring");

class productAPI extends MainAPI {
    /**
     * @return {object} product list
     * @param {*} productDetails - Contains pagination data
     * @param productId
     */
    async getProducts(productDetails) {
        return API.get(`${ENDPOINTS.GET_PRODUCTS}?${queryString.stringify(productDetails)}`);
    }

    /**
     * @return {object} product details
     * @param {*} productId - product id
     */
    async getProductById(productId) {
        return API.get(`${ENDPOINTS.GET_PRODUCT}/${productId}`);
    }

    /**
     * @return {object} product list
     * @param body - product name
     */
    async getProductsByName(body) {
        return API.get(`${ENDPOINTS.GET_PRODUCTS}/check-name`, body);
    }

    /**
     * @return {object} product types
     */
    async getProductTypes() {
        return API.get(`${ENDPOINTS.GET_PRODUCT_TYPE}`);
    }

    /**
     * @return no content
     * @param {*} productDetails
     */
    async postProducts(productDetails) {
        let newFormData = new FormData();

        newFormData.append("formData", JSON.stringify(productDetails.formDetails));

        if (productDetails.images.length > 0) {
            productDetails.images.forEach((image) => {
                newFormData.append("images", image);
            });
        }

        return API.post(ENDPOINTS.POST_PRODUCTS, newFormData, {
            header: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    /**
     * @return no content
     * @param {*} productDetails
     * @param productId
     */
    async putProduct(productId, productDetails) {
        let newFormData = new FormData();

        newFormData.append("formData", JSON.stringify(productDetails.formDetails));

        if (productDetails.images.length > 0) {
            productDetails.images.forEach((image) => {
                newFormData.append("images", image);
            });
        }

        return API.put(`${ENDPOINTS.PUT_PRODUCT}/${productId}`, newFormData, {
            header: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    /**
     * @return no content
     * @param {*} productDetails
     * @param productId
     */
    async reactivateProduct(productId) {
        return API.put(`${ENDPOINTS.PUT_PRODUCT}/${productId}/reactivate`);
    }

    /**
     * @return no content
     * @param productId
     */
    async deleteProduct(productId) {
        return API.delete(`${ENDPOINTS.DELETE_PRODUCT}/${productId}`);
    }

    /**
     * @return no content
     * @param {*} productDetails
     */
    async postOtherProducts(productDetails) {
        let newFormData = new FormData();

        newFormData.append("formData", JSON.stringify(productDetails.formDetails));

        newFormData.append("productImage", productDetails.productImage);

        return API.post(`${ENDPOINTS.POST_PRODUCTS}/others`, newFormData, {
            header: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    /**
     * @return {object} dog product details
     * @param {*} productId - product id
     */
    async getProductDogById(productId) {
        return API.get(`${ENDPOINTS.GET_PRODUCT}/${productId}/dog-details`);
    }

    /**
     * @return no content
     * @param {*} productDetails
     * @param productId
     */
    async putOtherProducts(productId, productDetails) {
        let newFormData = new FormData();

        newFormData.append("formData", JSON.stringify(productDetails.formDetails));

        newFormData.append("productImage", productDetails.productImage);

        return API.put(`${ENDPOINTS.PUT_PRODUCT}/${productId}/others`, newFormData, {
            header: {
                "Content-Type": "multipart/form-data",
            },
        });
    }

    /**
     * @return no content
     * @param productId
     */
    async productDelete(productId) {
        return API.delete(`${ENDPOINTS.DELETE_PRODUCT}/${productId}/delete`);
    }
    
    /**
     * @return
     * @param products
     */
    async postMultipleProducts(products) {
        return API.post(`${ENDPOINTS.POST_MULTIPLE_PRODUCTS}`, products);
    }
}

export default new productAPI();
